import React from 'react';
import CreateVideoState from './createVideoState/CreateVideoState';
import CreateVideoControlPanel from './components/CreateVideoControlPanel/CreateVideoControlPanel';
import Forms from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows/ModalWindows';
// import style from './index.module.scss';

const CreateVideoPage: React.FC = () => {
	return (
		<CreateVideoState>
			<CreateVideoControlPanel />
			<Forms />
			<ModalWindows />
		</CreateVideoState>
	);
};

export default CreateVideoPage;
